import api from "api";
import { call, put, takeLatest } from "redux-saga/effects";

import { changesets } from "../actions";
import { FETCH_CHANGESETS_START } from "../constants";
import { fetchPagedSagaFactory } from "./utils";

export const changesetsSaga = fetchPagedSagaFactory(
  api.Changesets.get,
  changesets.success,
  changesets.failed
);

export function* addChangesetSaga(action) {
  try {
    const { response, headers } = yield call(
      api.Changesets.create,
      {
        message: action.message
      },
      ["X-Crbs-Changeset-Token"]
    );
    yield put(changesets.addSuccess(response));
    return { response, token: headers["X-Crbs-Changeset-Token"] };
  } catch (error) {
    yield put(changesets.addFailed(error));
    return undefined;
  }
}

export function* watchFetchChangesets() {
  yield takeLatest(FETCH_CHANGESETS_START, changesetsSaga);
}
